import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Alert } from '@sravni/react-design-system/lib/Alert';
import { useBoolean } from '@sravni/react-utils';

import { useUserPromoContent } from '@src/reducers/promo';

import { PromoGuideSheet } from '../PromoGuideSheet';

import styles from './PromoInfoBox.module.scss';
import { GooglePromoInfoBox, DefaultPromoInfoBox } from './variants';

interface Props {
  children: ReactNode;
  isUserFromGoogleSearch: boolean;

  link: string;
  source: string;
}

export const PromoInfoBox = ({ children, isUserFromGoogleSearch, link, source }: Props) => {
  const [visible, toogle] = useBoolean();
  const { bonusAmount } = useUserPromoContent();

  const PromoInfoBoxVariant = isUserFromGoogleSearch ? GooglePromoInfoBox : DefaultPromoInfoBox;

  return (
    <Alert
      className={classNames(styles.alert, { [styles.blueAlert]: isUserFromGoogleSearch })}
      title={<PromoInfoBoxVariant onOpenSheet={toogle.on} bonusAmount={bonusAmount} />}
    >
      <div>{children}</div>

      <PromoGuideSheet visible={visible} onClose={toogle.off} link={link} source={source} />
    </Alert>
  );
};
